<div *ngIf="rating <= 0.5" class="stars-rating" style="--rating: 0.5">
  <div class="rating"></div>
</div>
<div
  *ngIf="rating > 0.5 && rating <= 1"
  class="stars-rating"
  style="--rating: 1"
>
  <div class="rating"></div>
</div>
<div
  *ngIf="rating > 1 && rating <= 1.5"
  class="stars-rating"
  style="--rating: 1.5"
>
  <div class="rating"></div>
</div>

<div
  *ngIf="rating > 1.5 && rating <= 2"
  class="stars-rating"
  style="--rating: 2"
>
  <div class="rating"></div>
</div>
<div
  *ngIf="rating > 2 && rating <= 2.5"
  class="stars-rating"
  style="--rating: 2.5"
>
  <div class="rating"></div>
</div>

<div
  *ngIf="rating > 2.5 && rating <= 3"
  class="stars-rating"
  style="--rating: 3"
>
  <div class="rating"></div>
</div>
<div
  *ngIf="rating > 3 && rating <= 3.5"
  class="stars-rating"
  style="--rating: 3.5"
>
  <div class="rating"></div>
</div>

<div
  *ngIf="rating > 3.5 && rating <= 4"
  class="stars-rating"
  style="--rating: 4"
>
  <div class="rating"></div>
</div>
<div
  *ngIf="rating > 4 && rating <= 4.5"
  class="stars-rating"
  style="--rating: 4.5"
>
  <div class="rating"></div>
</div>

<div *ngIf="rating > 4.5" class="stars-rating" style="--rating: 5">
  <div class="rating"></div>
</div>

<div *ngIf="noRating > 0" class="number">( {{ noRating | number }} )</div>
